import { stringify } from "query-string";
import { DataPhoto } from "../models/UploadPhotosModel";
import { convertToBase64 } from "../utils/helper";
import { httpClient } from "./httpClient";
import { API_ENDPOINT_PATH, FRONT_IMAGES_PATH } from "../utils/const";
import configData from "./../config.json";

const apiUrl = configData.ServerUrl as string;

export default {
  getList: (resource: string, params: any) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      // sort: JSON.stringify([field, order]),
      // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      // filter: JSON.stringify(params.filter),
      _page: page,
      _perPage: perPage,
      _sort: field,
      _order: order,
    };

    const url = `${apiUrl}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json.docs,
      total: json.count,
    }));
  },

  getOne: (resource: string, params: any) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => ({
      data: json,
    })),

  getMany: (resource: string, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({
      data: json.docs,
    }));
  },

  getManyReference: (resource: string, params: any) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json.docs,
      total: json.count,
    }));
  },

  update: (resource: string, params: any) =>
    httpClient(`${apiUrl}/${resource}/${params.id}`, {
      method: "PUT",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json })),

  updateMany: (resource: string, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: "PUT",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  create: async (resource: string, params: DataPhoto): Promise<any> => {
    if (resource === API_ENDPOINT_PATH) {
      const file = params.data.rawData;
      const base64File = await convertToBase64(file);
      params.data.rawData = base64File;
    }
    const { json } = await httpClient(apiUrl, {
      method: "POST",
      body: JSON.stringify(params.data),
    });
    return {
      data: { ...params.data, id: json.id },
    };
  },

  delete: (resource: string, params: any) =>
    httpClient(`${apiUrl}?imageId=${params.id}`, {
      method: "DELETE",
    }).then(({ json }) => ({ data: json })),

  deleteMany: (resource: string, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: "DELETE",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
};
